import { Injectable, OnDestroy } from "@angular/core";
import { Subscription, timer } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StopwatchService implements OnDestroy {
  private minutes: number = 0;
  private seconds: number = 0;
  //private hours:number=0;
  private timerSub: Subscription = new Subscription();
  private running: boolean = false;
  public timeString: string = '';
  private subscribed: boolean = false;
  constructor() {}

  /**
   * @param timeObject optional wird übergeben, falls
   * Protokoll fortgesetzt wird
   * @description
   * Stopuhr starten
   */
  public start(timeObject?: {
    minutes: number;
    seconds: number
  }) {
    if (typeof timeObject !== "undefined") {
      this.minutes = timeObject.minutes;
      this.seconds = timeObject.seconds;
    }
    if (this.running === false) {
      this.running = true;
    }
    if (this.subscribed === false) {
      this.timerSub = timer(0, 1000).subscribe(() => {
        this.subscribed = true;
        this.seconds++;
        if (this.seconds % 60 === 0) {
          this.minutes += 1;
          this.seconds = 0;
          /*
          if((this.minutes%60)===0){
            this.hours+=1;
            this.minutes=0;
          }*/
        }
        this.setTimeString();
      });
    }
  }
  /**
   * @description
   * Stopuhr stoppen
   */
  public stop() {
    this.running = false;
    if (this.timerSub !== null) {
      this.timerSub.unsubscribe();
    }
    this.subscribed = false;
  }
  /**
   * Stoppen und Reset()
   */
  public reset() {
    this.stop();
    this.seconds = 0;
    this.minutes = 0;
    this.setTimeString();
  }

  public setTimeString() {
    let seconds: string = "";
    let minutes: string = "";
    //let hours:string="";
    if (this.seconds < 10) {
      seconds += "0";
    }
    seconds += this.seconds.toString();
    if (this.minutes < 10) {
      minutes += "0";
    }
    minutes += this.minutes.toString();
    /*if (this.hours<10){
        hours+="0";
      }
      hours+=this.hours.toString();*/
    //this.timeString=hours+":"+minutes+":"+seconds;
    this.timeString = minutes + ":" + seconds;
  }

  public getMinutes() {
    return this.minutes;
  }

  public getSeconds() {
    return this.seconds;
  }

  public ngOnDestroy() {
    this.reset();
  }
}
